import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {changeLayer} from '../../actionCreators';

const LayerOption = ({checked, image, label, onClick}) => (
    <div className={classNames('layer-option', {checked})} onClick={onClick}>
        <div className="image-container">
            <img src={image} alt={label} />
        </div>
        <span>{label}</span>
    </div>
);

const mapDispatchToProps = (dispatch, {value}) => ({
    onClick: () => dispatch(changeLayer(value)),
});

export default connect(null, mapDispatchToProps)(LayerOption);
